import React from 'react';
import { useTheme } from 'styled-components';

import { LOGO_FULL, SKYSPECS_LOGO } from 'utils/constants';
import { MAINTENANCE_MODE_ENABLED } from 'utils/env';

import { MaintenanceContainer, PrimaryLogo, SkySpecsLogo } from './Maintenance.style';

interface Props {
  children: React.ReactNode;
}

function Maintenance({ children }: Props) {
  const theme = useTheme();

  if (!MAINTENANCE_MODE_ENABLED) {
    return <>{children}</>;
  }

  return (
    <MaintenanceContainer>
      <PrimaryLogo
        alt={theme.isHorizonGridVisualRefresh ? 'skyspecs-logo' : 'horizon-logo'}
        src={theme.isHorizonGridVisualRefresh ? SKYSPECS_LOGO : LOGO_FULL}
      />
      <main>
        <h1>Sorry! We're currently down for maintenance.</h1>
        <h2>We'll be back up as soon as possible.</h2>
        <p>
          Questions?{' '}
          <a
            href="https://support.skyspecs.com/hc/en-us/requests/new"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Support
          </a>
        </p>
      </main>
      <SkySpecsLogo alt="skyspecs-logo" src="/logos/skyspecs/skyspecs-black.png" />
    </MaintenanceContainer>
  );
}

export default Maintenance;
